function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { uniqueId } from "../utils/unique-id";

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.id = uniqueId();
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "setIndeterminate",
    value: function setIndeterminate(element, isIndeterminate) {
      if (isIndeterminate) element.setAttribute('data-indeterminate', '');else element.removeAttribute('data-indeterminate');
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick,
          isIndeterminate = _this$props.isIndeterminate,
          partial = _this$props.partial,
          onLabelClick = _this$props.onLabelClick;
      return React.createElement("div", {
        className: cx(className, 'checkbox')
      }, React.createElement("input", {
        id: this.id,
        type: "checkbox",
        checked: checked,
        readOnly: readOnly,
        onChange: onChange,
        onClick: onClick,
        disabled: disabled,
        className: cx('checkbox-input', {
          disabled: disabled
        }),
        ref: function ref(elem) {
          return elem && _this.setIndeterminate(elem, isIndeterminate);
        }
      }), React.createElement("label", {
        onClick: onLabelClick,
        className: cx({
          partial: partial
        }),
        htmlFor: this.id
      }, children));
    }
  }]);

  return Checkbox;
}(Component);

_defineProperty(Checkbox, "propTypes", {
  children: PropTypes.any,
  className: PropTypes.string,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  isIndeterminate: PropTypes.bool,
  partial: PropTypes.bool,
  onLabelClick: PropTypes.func
});

export default Checkbox;